import React, { useState, useEffect, forwardRef } from 'react';
import './tableOrganizations.css'
import moment from 'moment-timezone';
import 'moment/locale/es-us';
import { Table, Button, Flex } from 'antd';

import {
    EditOutlined,
    EyeOutlined
} from '@ant-design/icons';

const TableOrganizations = forwardRef((props, ref) => {
    const [dataSource, setDataSource] = useState([])
    const [columns, setColumns] = useState([])

    useEffect(() => {
        // Configurar el idioma a 'es-us'
        moment.locale('es-us');
    }, []);

    useEffect(() => {
        let columns = [
            {
                title: 'Organización',
                dataIndex: 'org_name',
                key: 'org_name',
            },
            {
                title: 'Nit',
                dataIndex: 'org_nit',
                key: 'org_nit',
            },
            {
                title: 'Email',
                dataIndex: 'org_email',
                key: 'org_email',
            },
            {
                title: 'Nombre de contacto',
                dataIndex: 'org_responsible',
                key: 'org_responsible',
                render: (text, row, index) => {
                    return <span>{`${row.org_responsible_name} ${row.org_responsible_last_name}`}</span>
                }
            },
            {
                title: 'Teléfono de contacto',
                dataIndex: 'org_responsible_tel',
                key: 'org_responsible_tel',
            },
            {
                title: 'Email de contacto',
                dataIndex: 'org_responsible_email',
                key: 'org_responsible_email',
            },
            {
                title: 'Activa',
                dataIndex: 'org_active',
                key: 'org_active',
                render: (text, row, index) => {
                    return <span>{row.org_active ? `Activa` : `Inactiva`}</span>
                }
            },
            {
                title: 'Fecha de creación',
                dataIndex: 'org_created_at',
                key: 'org_created_at',
                render: (text, row, index) => {
                    return <span>{moment(row.org_created_at).tz('America/Bogota').format('LL')}</span>
                }
            },
            {
                title: 'Hora de creación',
                dataIndex: 'org_created_at_hour',
                key: 'org_created_at_hour',
                render: (text, row, index) => {
                    return <span>{moment(row.org_created_at).tz('America/Bogota').format('LTS')}</span>
                }
            },
            {
                title: '',
                dataIndex: 'org_actions',
                key: 'org_actions',
                render: (text, row, index) => {
                    return <Flex gap="small" wrap>
                        {/* <Button onClick={() => setOrganizationValuesToEdit(row)} type="primary" icon={<EditOutlined />} size={"large"} title='Editar organización' /> */}
                        <Button onClick={() => setOrganizationValuesToSee(row)} style={{ backgroundColor: "#293790", color: "white"}} icon={<EyeOutlined />} size={"large"} title='Ver información de la organización' />
                    </Flex>
                }
            }
        ]

        setColumns(columns)

        let dataSource = props.data

        setDataSource(dataSource)

    }, [props.data])

    const setOrganizationValuesToSee = (org) => {
        props.setOrganizationValuesToSee(org)
    }

    return (
        <Table 
            className="custom-green-table"
            size={"small"} 
            dataSource={dataSource} 
            columns={columns} 
            pagination={{ pageSize: 10, position: ['bottomRight'] }} 
            scroll={{ x: 'max-content' }}
        />
    )
})

export default TableOrganizations;